import React from 'react';
import {
  InfoBupPanel,
  DataBupPanel,
  ModeBupPanel,
  PageLayout,
  ResourcesBupPanel,
} from '@BUP/components';
import { Row, Col } from 'antd';
import { useAuth } from '@BUP/hooks';
import { useTranslation } from 'react-i18next';
import { isModeBup, isData } from '@BUP/services/BraveUp';
import styles from './home.module.css';

const HomePage = () => {
  const { user } = useAuth();
  const [t] = useTranslation();

  return (
    <PageLayout>
      <div className="home-page-container">
        <div className="content-wrapper">
          <h1 className={styles.title}>{`${t('pages.home.welcomeTitle')} ${
            user?.name
          }!`}</h1>
          <Row gutter={[24, 40]}>
            <Col sm={24} xl={16}>
              <InfoBupPanel title="BRAVE UP!" />
            </Col>
            {isModeBup(user) ? (
              <Col sm={24} xl={8} className={styles.mode_bup_wrapper}>
                <ModeBupPanel title={t('pages.home.bupSection')} />
              </Col>
            ) : null}
          </Row>
          <Row
            gutter={[48, 40]}
            className={styles.container_two}
            type="flex"
            justify="space-between"
          >
            {isData(user) ? (
              <Col sm={24} xl={9} className={styles.data_wrapper}>
                <DataBupPanel title={t('pages.home.dataSection')} />
              </Col>
            ) : null}
            <Col sm={24} xl={15}>
              <ResourcesBupPanel title={t('pages.home.resourceSection')} />
            </Col>
          </Row>
        </div>
      </div>
    </PageLayout>
  );
};

export default HomePage;
